import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from '../interfaces/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private myAppUrl: string;
  private myApiUrl: string;

  constructor(private http: HttpClient) {
    this.myAppUrl = environment.endpoint;
    this.myApiUrl = 'api/users'
   }
   signIn(user: User): Observable<any> {
    return this.http.post<any>(`${this.myAppUrl}${this.myApiUrl}`, user);
  }
   signIn2(user: User): Observable<any> {
    return this.http.post(`${this.myAppUrl}${this.myApiUrl}`, user);
   }

   login(user: User): Observable<string> {
    return this.http.post<string>(`${this.myAppUrl}${this.myApiUrl}/login`, user)
   }
   getLastUser(): Observable<any> {
    return this.http.get<any>(`${this.myAppUrl}${this.myApiUrl}/lastUser`);
   }
   getUser(id: number): Observable<any> {
    return this.http.get<any>(`${this.myAppUrl}${this.myApiUrl}/${id}`);
   }
   deleteUser(id: number): Observable<void> {
    return this.http.delete<void>(`${this.myAppUrl}${this.myApiUrl}/${id}`)
  }
  // Método para actualizar un usuario por nombre de usuario y contraseña
  updateUser(username: string, password: string, user: User): Observable<{ msg: string }> {
    // Asignar la nueva contraseña al objeto user
    user.password = password;
  
    console.log("username recibido: " + username);
    console.log("user enviado:", user);
  
    // Realizar la solicitud PUT para actualizar el usuario
    return this.http.put<{ msg: string }>(`${this.myAppUrl}${this.myApiUrl}/users/${username}`, user);
  }
  updateUserById(id: string, user: User): Observable<any> {
    return this.http.put<any>(`${this.myAppUrl}${this.myApiUrl}/id/${id}`, user);
  }
  getUserByEmail(email: string): Observable<User> {
    return this.http.get<User>(`${this.myAppUrl}${this.myApiUrl}/email/${email}`);
  }
  updateUserStatus(id: number, status: number): Observable<void> {
    return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}/status/${id}`, {status});
  }

  
}
